import React, { useRef, useState, useEffect } from "react";
import "./style.css";


function BaseSvg({svgRef, scale, setScale, translate,  setTranslate, dragStart, setDragStart,  children}) {

  const zoomStep = 0.2;
  const maxZoom = 4;
  const minZoom = 0.95;


  const handleMouseDown = (e) => {
    if (scale === 0.95) return; // No se puede mover en zoom 1
    setDragStart({ x: e.clientX, y: e.clientY });
  };

  const handleMouseMove = (e) => {
    if (!dragStart || scale === 0.95) return;

    const dx = e.clientX - dragStart.x;
    const dy = e.clientY - dragStart.y;

    setTranslate((prev) => ({
      x: prev.x + dx,
      y: prev.y + dy,
    }));

    setDragStart({ x: e.clientX, y: e.clientY });
  };

  const handleMouseUp = () => {
    setDragStart(null);
  };

  //zoom in / zoom out con el scroll del mouse
  const handleWheel = (e) => {
    e.preventDefault(); // evita el scroll normal de la página

    const delta = e.deltaY;

    if (delta < 0) {
      // Scroll hacia arriba → zoom in
      setScale((prev) => Math.min(prev + zoomStep, maxZoom));
    } else if (delta > 0) {
      // Scroll hacia abajo → zoom out
      setScale((prev) => {
        const newScale = Math.max(prev - zoomStep, minZoom);
        if (newScale === 0.95) setTranslate({ x: 0, y: 0 }); // reset si vuelve a zoom 1
        return newScale;
      });
    }
  };


  return (
    <svg
      ref={svgRef}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 879.8 507.21"
      className="w-full h-full border"
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      onWheel={handleWheel}
      style={{
        cursor: scale > 0.95 ? (dragStart ? "grabbing" : "grab") : "default",
      }}
    >
       
      {children}

    </svg>
  );
}

export default BaseSvg;
